import styled from 'styled-components'
import Slider from 'rc-slider'

import styledTheme from '../../../../styles/theme'
import typeStyle from '../../../../styles/typeStyle'

const ANY_MARK = 5

const MARKS: Record<number, string> = {
  1: '1hr',
  2: '2hrs',
  3: '3hrs',
  4: '4hrs',
  [ANY_MARK]: 'Any',
}

const toSliderValue = (driveTime?: number | null): number =>
  driveTime ? Math.min(Math.ceil(driveTime / 60), ANY_MARK - 1) : ANY_MARK

const toDriveTime = (mark: number): number | null =>
  mark === ANY_MARK ? null : mark * 60

// Horizontal insets match PriceRange (half a handle each side) so the end
// dots line up with the price handles and nothing overhangs the box;
// bottom padding keeps the mark labels inside the panel
const RangeWrapper = styled.div`
  padding: 0 10px 28px;

  .rc-slider-mark-text {
    ${typeStyle('-ds-font-body-sm-regular')}
  }

  /* Enlarge the default 8px step dots, re-centred on the 4px rail;
     inactive dots take the rail grey, active ones the track teal */
  .rc-slider-dot {
    width: 12px;
    height: 12px;
    bottom: -4px;
    margin-left: 0;
    border-color: ${styledTheme?.['-ds-neutral-300']?.value};
    opacity: 1;
  }

  .rc-slider-dot-active {
    border-color: ${styledTheme?.['-ds-core-400']?.value};
  }
`

// No horizontal margins: rc-slider v10 centres handles and dots with
// translateX(-50%), so legacy negative margins shift them off-position
const handleStyle = {
  borderColor: styledTheme.brand.jungle,
  height: 20,
  width: 20,
  marginTop: -8,
  backgroundColor: 'white',
  opacity: 1,
}

type DriveTimeFilterProps = {
  driveTime?: number | null
  onChange: (driveTime: number | null) => any
}

const DriveTimeFilter = ({ driveTime, onChange }: DriveTimeFilterProps) => (
  <RangeWrapper>
    <Slider
      min={1}
      max={ANY_MARK}
      step={1}
      marks={MARKS}
      value={toSliderValue(driveTime)}
      onChange={(value) => onChange(toDriveTime(value as number))}
      trackStyle={{
        backgroundColor: styledTheme?.['-ds-core-400']?.value,
        borderRadius: 0,
      }}
      railStyle={{
        backgroundColor: styledTheme?.['-ds-neutral-300']?.value,
      }}
      handleStyle={handleStyle}
      ariaLabelForHandle="Maximum drive time"
    />
  </RangeWrapper>
)

export default DriveTimeFilter
